// 1. CREATE API TYPES
export const CREATE_SUPPLIER_REQUEST = "CREATE_SUPPLIER_REQUEST";
export const CREATE_SUPPLIER_SUCCESS = "CREATE_SUPPLIER_SUCCESS";
export const CREATE_SUPPLIER_FAILURE = "CREATE_SUPPLIER_FAILURE";

// 2. GET ALL API TYPES
export const GET_ALL_SUPPLIER_REQUEST = "GET_ALL_SUPPLIER_REQUEST";
export const GET_ALL_SUPPLIER_SUCCESS = "GET_ALL_SUPPLIER_SUCCESS";
export const GET_ALL_SUPPLIER_FAILURE = "GET_ALL_SUPPLIER_FAILURE";

// 3. GET ONE API TYPES
export const GET_ONE_SUPPLIER_REQUEST = "GET_ONE_SUPPLIER_REQUEST";
export const GET_ONE_SUPPLIER_SUCCESS = "GET_ONE_SUPPLIER_SUCCESS";
export const GET_ONE_SUPPLIER_FAILURE = "GET_ONE_SUPPLIER_FAILURE";

// 4. EDIT/UPDATE API TYPES
export const EDIT_SUPPLIER_REQUEST = "EDIT_SUPPLIER_REQUEST";
export const EDIT_SUPPLIER_SUCCESS = "EDIT_SUPPLIER_SUCCESS";
export const EDIT_SUPPLIER_FAILURE = "EDIT_SUPPLIER_FAILURE";

// 5. DELETE API TYPES
export const DELETE_SUPPLIER_REQUEST = "DELETE_SUPPLIER_REQUEST";
export const DELETE_SUPPLIER_SUCCESS = "DELETE_SUPPLIER_SUCCESS";
export const DELETE_SUPPLIER_FAILURE = "DELETE_SUPPLIER_FAILURE";


export const UPLOADCSV_SUPPLIER_INFORMATION_REQUEST = "UPLOADCSV_SUPPLIER_INFORMATION_REQUEST";
export const UPLOADCSV_SUPPLIER_INFORMATION_SUCCESS = "UPLOADCSV_SUPPLIER_INFORMATION_SUCCESS";
export const UPLOADCSV_SUPPLIER_INFORMATION_FAILURE = "UPLOADCSV_SUPPLIER_INFORMATION_FAILURE";